import { AssetStatisticType, StatisticConnector, StatisticOperator, StatisticUnit } from '../../../../../enums/assetStatistic';
import type { AssetGeometryType } from '../../../../../types/InfrastructureManagerTypes';

// Display order of the STATISTIC select; Count is the story's default.
export const STATISTIC_TYPES = [
  AssetStatisticType.COUNT,
  AssetStatisticType.SUM,
  AssetStatisticType.AVG,
  AssetStatisticType.MIN,
  AssetStatisticType.MAX,
  AssetStatisticType.TOTAL_AREA,
  AssetStatisticType.TOTAL_LENGTH,
];

export const STATISTIC_TYPE_LABELS: Record<AssetStatisticType, string> = {
  [AssetStatisticType.COUNT]: 'Count',
  [AssetStatisticType.SUM]: 'Sum',
  [AssetStatisticType.AVG]: 'Average',
  [AssetStatisticType.MIN]: 'Min',
  [AssetStatisticType.MAX]: 'Max',
  [AssetStatisticType.TOTAL_AREA]: 'Area',
  [AssetStatisticType.TOTAL_LENGTH]: 'Length',
};

// Calculated on a numeric field ("OF <field>").
export const FIELD_STATISTICS = new Set([AssetStatisticType.SUM, AssetStatisticType.AVG, AssetStatisticType.MIN, AssetStatisticType.MAX]);

// Geometry statistics pick a unit instead ("IN <unit>"); the first is the default.
export const UNIT_OPTIONS: Partial<Record<AssetStatisticType, StatisticUnit[]>> = {
  [AssetStatisticType.TOTAL_LENGTH]: [StatisticUnit.KM, StatisticUnit.M, StatisticUnit.MI],
  [AssetStatisticType.TOTAL_AREA]: [StatisticUnit.KM2, StatisticUnit.HA, StatisticUnit.ACRES],
};

// BE: Length is LINESTRING-only for now; the story also allows polygons (perimeter).
export const isStatisticSupported = (geometry: AssetGeometryType, type: AssetStatisticType) => {
  if (type === AssetStatisticType.TOTAL_AREA) return geometry === 'POLYGON';
  if (type === AssetStatisticType.TOTAL_LENGTH) return geometry === 'LINESTRING';
  return true;
};

// BE: there is no NOT_CONTAINS, so the approved UI's "Not Like" is dropped.
export const OPERATOR_LABELS: Record<StatisticOperator, string> = {
  [StatisticOperator.IS]: 'Is',
  [StatisticOperator.IS_NOT]: 'Is Not',
  [StatisticOperator.CONTAINS]: 'Contains',
  [StatisticOperator.GT]: 'Greater Than',
  [StatisticOperator.GTE]: 'Greater Than or Equal',
  [StatisticOperator.LT]: 'Less Than',
  [StatisticOperator.LTE]: 'Less Than or Equal',
  [StatisticOperator.IS_EMPTY]: 'Is Empty',
  [StatisticOperator.IS_NOT_EMPTY]: 'Is Not Empty',
};

export const VALUELESS_OPERATORS = new Set([StatisticOperator.IS_EMPTY, StatisticOperator.IS_NOT_EMPTY]);

export const CONNECTOR_OPTIONS = [StatisticConnector.AND, StatisticConnector.OR];

export const BOOLEAN_VALUES = ['true', 'false'];

export const FIELD_VALUES_SEARCH_DEBOUNCE_MS = 300;

export type WhereConditionField = 'connector' | 'field' | 'operator' | 'value';

// An item of the shared /icons library (Map Portal's icon picker reads the same list).
export interface LibraryIcon {
  id: number;
  name: string;
  s3Key: string;
  url: string;
}

// Form draft of one WHERE row; `value` stays text until save converts it to the field's type.
export interface ConditionRow {
  id: string;
  connector: StatisticConnector | null;
  field: string | null;
  operator: StatisticOperator | null;
  value: string | null;
}
